import { render, staticRenderFns } from "./ekurunler.vue?vue&type=template&id=d54fabba&"
import script from "./ekurunler.vue?vue&type=script&lang=js&"
export * from "./ekurunler.vue?vue&type=script&lang=js&"
import style0 from "./ekurunler.vue?vue&type=style&index=0&id=d54fabba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports